// /* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { Box, Button, CircularProgress, Grid, InputAdornment, MenuItem, Stack, useTheme } from "@mui/material";
import { checkRoomAvailability, listAllRoomTypes, resetAvalableRoomsData } from "../../../store/actions";
import { CalendarMonth, RoomPreferences } from "@mui/icons-material";
import { CssTextField } from "../../../components/TextField";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import { tokens } from "../../../theme";
import Header from "../../../components/Header";
import moment from "moment";
import * as yup from "yup";
import PlusOrMinusButton from "../../../components/PlusOrMinusButton";
import { isPmsConnected } from "../../../utils";

const CheckRoomAvailability = ({ setPage, setProgress, setCheckingdata }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();
    const checkinRef = useRef();
    const checkoutRef = useRef();
    const [selectedRoomType, setSelectedRoomType] = useState("");

    const { isLoading, roomTypes } = useSelector(
        ({
            loading, admin: {
                roomTypes: { list, showViewMore },
            }
        }) => ({
            isLoading: loading,
            roomTypes: list,
        })
    );

    useEffect(() => {
        document.title = 'New Booking';
        dispatch(listAllRoomTypes({ isForDropdown: true }));
        dispatch(resetAvalableRoomsData());
    }, [dispatch]);

    const handleFormSubmit = async (values) => {
        let roomsData = [{
            room_number: 1,
            no_of_adults: values.numOfAdults,
            no_of_childs: values.numOfChilds,
        }]
        if (selectedRoomType && selectedRoomType !== "no_preference") {
            roomsData[0].roomtype_id = selectedRoomType
        }
        let data = {
            // ...values,
            checkinDate: moment(values.checkinDate, "YYYY-MM-DD").unix(),
            checkoutDate: moment(values.checkoutDate, "YYYY-MM-DD").unix(),
            rooms: roomsData,
        };
        // console.log(data);
        await dispatch(checkRoomAvailability(data));
        setCheckingdata(data);
        setProgress(66);
        setPage(2);
    };
    const initialValues = {
        checkinDate: moment().format("YYYY-MM-DD"),
        checkoutDate: moment().add(1, "days").format("YYYY-MM-DD"),
        numOfAdults: 2,
        numOfChilds: 0,
    };
    const checkoutSchema = yup.object().shape({
        numOfAdults: yup.number().min(1, "Number of Adults must be greater than or equal to 1").required("Required"),
    });

    return (
        <Box mt="20px">
            <Grid container spacing={2}>
                <Grid item lg={7} xs={12}>
                    <Header title="Check room availability" titleVariant="h4" />
                    <Box
                        width="100%"
                        p={2}
                        borderRadius={2}
                        backgroundColor={colors.primary[400]}
                    >
                        <Formik onSubmit={handleFormSubmit} initialValues={initialValues} validationSchema={checkoutSchema}>
                            {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
                                <form onSubmit={handleSubmit}>
                                    <Grid container spacing={3}>
                                        <Grid item md={6} xs={12}>
                                            <Stack>
                                                <CssTextField
                                                    fullWidth
                                                    required
                                                    // size="small"
                                                    type="date"
                                                    placeholder="Checkin Date"
                                                    label="Checkin Date"
                                                    onBlur={handleBlur}
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                        if (moment(e.target.value).add(1, "days").format("YYYY-MM-DD") > values.checkoutDate) {
                                                            setFieldValue(
                                                                'checkoutDate',
                                                                moment(e.target.value).add(1, "days").format("YYYY-MM-DD")
                                                            );
                                                        }
                                                    }}
                                                    name="checkinDate"
                                                    value={values.checkinDate}
                                                    inputProps={{ min: moment().format("YYYY-MM-DD") }}
                                                    error={!!touched.checkinDate && !!errors.checkinDate}
                                                    helperText={touched.checkinDate && errors.checkinDate}
                                                    inputRef={checkinRef}
                                                    onClick={() => checkinRef.current.showPicker()} 
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <CalendarMonth sx={{ cursor: "pointer" }} />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <Stack>
                                                <CssTextField
                                                    fullWidth
                                                    required
                                                    // size="small"
                                                    type="date"
                                                    placeholder="Checkout Date"
                                                    label="Checkout Date"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    name="checkoutDate"
                                                    value={values.checkoutDate}
                                                    inputProps={{ min: moment(values.checkinDate).add(1, "days").format("YYYY-MM-DD") }}
                                                    error={!!touched.checkoutDate && !!errors.checkoutDate}
                                                    helperText={touched.checkoutDate && errors.checkoutDate}
                                                    inputRef={checkoutRef}
                                                    onClick={() => checkoutRef.current.showPicker()} 
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <CalendarMonth sx={{ cursor: "pointer" }} />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <PlusOrMinusButton 
                                                min={1}
                                                max={5}
                                                size="large"
                                                label="Number of Adults"
                                                name="numOfAdults"
                                                value={values.numOfAdults}
                                                handleChange={(value) => setFieldValue("numOfAdults" ,value)}
                                            />
                                            {/* <CssTextField
                                                fullWidth
                                                // size="small"
                                                type="number"
                                                label="Number of Adults"
                                                placeholder="Number of Adults"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.numOfAdults}
                                                name="numOfAdults"
                                                required
                                                error={!!touched.numOfAdults && !!errors.numOfAdults}
                                                helperText={touched.numOfAdults && errors.numOfAdults}
                                                InputProps={{
                                                    inputProps: { min: 1 },
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Group />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            /> */}
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <PlusOrMinusButton 
                                                min={1}
                                                max={5}
                                                size="large"
                                                label="Number of Children"
                                                name="numOfChilds"
                                                value={values.numOfChilds}
                                                handleChange={(value) => setFieldValue("numOfChilds" ,value)}
                                            />
                                            {/* <CssTextField
                                                fullWidth
                                                required
                                                // size="small"
                                                type="number"
                                                label="Number of Childs"
                                                placeholder="Number of Childs"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.numOfChilds}
                                                name="numOfChilds"
                                                error={!!touched.numOfChilds && !!errors.numOfChilds}
                                                helperText={touched.numOfChilds && errors.numOfChilds}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <EscalatorWarning />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            /> */}
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <CssTextField
                                                fullWidth
                                                select
                                                // size="small"
                                                value={selectedRoomType || "no_preference"}
                                                label="Room Type"
                                                onChange={(e) => setSelectedRoomType(e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <RoomPreferences />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            >
                                                <MenuItem value={"no_preference"}>
                                                    {"No Preference"}
                                                </MenuItem>
                                                {roomTypes?.map((roomType, index) => (
                                                    <MenuItem value={roomType._id} key={index}>
                                                        {roomType.name}
                                                    </MenuItem>
                                                ))}
                                            </CssTextField>
                                        </Grid>
                                        {/* <Grid item md={6} xs={12}>
                                            <Button
                                                fullWidth
                                                size="large"
                                                color="secondary"
                                                variant="outlined"
                                                sx={{ fontSize: "15px" }}
                                            >
                                                <b>Cancel</b>
                                            </Button>
                                        </Grid> */}
                                        <Grid item md={12} xs={12}>
                                            <Button
                                                fullWidth
                                                // size="small"
                                                type="submit"
                                                color="secondary"
                                                variant="contained"
                                                sx={{ fontSize: "15px" }}
                                                disabled={isPmsConnected()}
                                            >
                                                {isLoading ? <CircularProgress color="inherit" size={24} /> : <b>Check available rooms</b>}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Formik>
                    </Box>
                </Grid>
            </Grid>
        </Box >
    );
};

export default CheckRoomAvailability;